import React from 'react';
import { Grid, Paper } from '@material-ui/core';

import Styles from './MessageBox.module.scss';

interface Props {
    title?: string;
    icon?: React.ReactNode;
    buttonBefore?: JSX.Element;
    buttonText?: string;
    buttonURL?: string;
    buttonAfter?: JSX.Element;
}

const MessageBox = (props: Props) => {
    const { title, icon, buttonBefore, buttonText, buttonURL, buttonAfter } = props;

    return (
        <Paper>
            <Grid container spacing={3} className={Styles.MessageBox}>
                <Grid item xs={12}>
                    {(icon || title) && (
                        <h4>
                            {icon}

                            {icon && title && <span style={{ marginRight: '1rem' }}></span>}

                            {title}
                        </h4>
                    )}

                    {buttonBefore && <p>{buttonBefore}</p>}

                    {buttonText && buttonURL && (
                        <a className={Styles.button} target="_blank" rel="noopener noreferrer" href={buttonURL}>
                            {buttonText}
                        </a>
                    )}

                    {buttonAfter && <p>{buttonAfter}</p>}
                </Grid>
            </Grid>
        </Paper>
    );
};

MessageBox.defaultProps = {};

export default MessageBox;
